import * as MutationTypes from "../mutation_types"
import { State, AuthHeaders, MedicalInformation } from "../store_types"
import { callMedicalInformationsAPI, callLatestMedicalInformationsAPI } from "../../api/medical_informations"
import { AxiosResponseHeaders } from "axios"

const getDefaultState  = () => {
  return {
    monthlyMedicalInformations : [],
    latestMedicalInformations : []
  }
}

const medicalInformations = {
  state: () => getDefaultState(),

  getters: {
    monthlyMedicalInformations (state : State) {
      return state.monthlyMedicalInformations
    },
    latestMedicalInformations (state : State) {
      return state.latestMedicalInformations
    },
  },

  actions: {
    fetchMedicalInformations({ commit, getters }: { commit: (mutationType: string, resultData: AxiosResponseHeaders | Array<MedicalInformation>) => void, getters: { [authHeaders: string]: AuthHeaders | Date }}){
      return new Promise<void>((resolve, reject) => {
        callMedicalInformationsAPI(
          getters.authHeaders as AuthHeaders,
          {
            targetMonth: getters.selectedMedicalInformationDate as Date
          },
          // Success
          (headers: AxiosResponseHeaders, results: Array<MedicalInformation>) => {
            commit(MutationTypes.ASSIGN_AUTH_HEADERS, headers)
            commit(MutationTypes.ASSIGN_MONTHLY_MEDICAL_INFORMATIONS, results)
            resolve()
          },
          // Failure
          () => {
            reject()
          })
      })
    },
    fetchLatestMedicalInformations({ commit, getters }: { commit: (mutationType: string, resultData: AxiosResponseHeaders | Array<MedicalInformation>) => void, getters: { [authHeaders: string]: AuthHeaders }}){
      return new Promise<void>((resolve, reject) => {
        callLatestMedicalInformationsAPI(
          getters.authHeaders as AuthHeaders,
          // Success
          (headers: AxiosResponseHeaders, results: Array<MedicalInformation>) => {
            commit(MutationTypes.ASSIGN_AUTH_HEADERS, headers)
            commit(MutationTypes.ASSIGN_LATEST_MEDICAL_INFORMATIONS, results)
            resolve()
          },
          // Failure
          () => {
            reject()
          })
      })
    },
    resetMedicalInformationsState ({ commit }: { commit: (mutationType:string) => void }) {
      commit(MutationTypes.RESET_MEDICAL_INFORMATIONS_STATE)
    },
  },
  mutations: {
    [MutationTypes.ASSIGN_MONTHLY_MEDICAL_INFORMATIONS](state: State, results: Array<MedicalInformation>) {
      state.monthlyMedicalInformations = results
    },
    [MutationTypes.ASSIGN_LATEST_MEDICAL_INFORMATIONS](state: State, results: Array<MedicalInformation>) {
      state.latestMedicalInformations = results
    },
    [MutationTypes.RESET_MEDICAL_INFORMATIONS_STATE](state: State) {
      Object.assign(state, getDefaultState())
    },
  },
}

export default medicalInformations
